
import * as types from './mutations_types'
import {store} from '../../utils/';

export default {
	[types.UPDATE_USERINFO](state, data) {
    state.user = {
      account: data.account,
      nick: data.nick,
      avatar: data.avatar
    };
		store.set('user', state.user);
    state.menus = data.menu;
		store.set('menus', state.menus);
		
	},

	[types.UPDATE_TOKEN](state, data) {
    state.token = data.accessToken;
    store.set('token', state.token);
    state.refreshToken = data.refreshToken;
    store.set('refreshToken', state.refreshToken);
	},
	


	[types.REMOVE_USERINFO](state) {
    state.user = null;
		store.remove('user');
		state.menus = null;
    store.remove('menus');
    state.token = null;
    store.remove('token');
    state.refreshToken = null;
    store.remove('refreshToken');
	},

	
	[types.UPDATE_IDENTITY](state, identity) {
		state.identity = identity;
		store.set('identity', state.identity);
	},
	
	[types.UPDATE_SELECTEDMENU](state, menu) {
		state.selectedMenu = menu;
		if (state.selectedMenu.rights && state.selectedMenu.rights.length > 0) {
			state.menuRight = {};
			for (let item of state.selectedMenu.rights) { 
				let code = item.code.toString().substring(menu.code.toString().length);
				state.menuRight[code] = item.code;
			}
		} else { 
			state.menuRight = {};
		}
	},


	[types.UPDATE_USERPWDFLAG](state, data) {
		state.user.flag = data;
		store.set('user', state.user);
	},

	
	
};